var exports = {
  "kL": "x0a7806d5--e3f956--container",
  "DD": "x0a7806d5--e3f956--title",
  "AS": "x0a7806d5--e3f956--item",
};

module.exports = exports;
